import {connect} from 'react-redux';
import Discipline from '../../components/disciplines/Discipline';
import * as actions from '../../actions/discipline';
import * as perfomanceActions from '../../actions/performance';
import {fetchCourseBooks, resetCourseBooks} from '../../reducers/CourseBooks/actions';
import {getBooksInfo, getSignedCopyFile} from "../../actions/educationWorkPrograms";

const mapStateToProps = ({discipline, performance, courseBooksReducer, booksInfo, auth}) => ({
    disciplineDetails: discipline.disciplineDetails,
    course: performance.course,
    isLoading: discipline.isLoading,
    idCurr: discipline.idCurr,
    ccId: discipline.ccId,
    books: courseBooksReducer.list,
    booksInfo: booksInfo,
    isTeacher: auth.isTeacher,
    moreInfo: discipline.moreInfo
});

const mapDispatchToProps = dispatch => ({
    didMount: params => dispatch(actions.discipline(params)),
    getFile: (idCurriculum, eyId, tlid, oid, filename) =>
        dispatch(actions.file(idCurriculum, eyId, tlid, oid, filename)),
    getLessonsFile: (lesson_id, filename) =>
        dispatch(actions.lessonsFile(lesson_id, filename)),
    getCourse: courseId => dispatch(perfomanceActions.course(courseId)),
    fetchCourseBooks: courseId => dispatch(fetchCourseBooks(courseId)),
    getBooksInfo: booksArray => dispatch(getBooksInfo(booksArray)),
    resetBooks: () => dispatch(resetCourseBooks()),
    getMoreInfo: (currId, cid) => dispatch(actions.getMoreInfo(currId, cid)),
    getFile: (id, fileName) => dispatch(actions.getFile(id, fileName)),
    getSignedCopyFile: courseId => dispatch(getSignedCopyFile(courseId))

});

export default connect(mapStateToProps, mapDispatchToProps)(Discipline);
